/* eslint-disable react/no-danger */
import React, { useCallback, useEffect, useState } from 'react'
import { NotificationContext } from 'app/contexts/notification/notification.context'
import { MessageType } from 'app/contexts/notification/notification.reducer'
import NotificationMessage from 'components/notification-message/notification-message'

type Props = {
  children: React.ReactNode
}

type NotificationObject = {
  isOpen: boolean
  title: string
  message: string
  type: MessageType
}

const NotificationProvider2 = ({ children }: Props) => {
  const [notification, setNotification] = useState<NotificationObject>({
    isOpen: false,
    title: '',
    message: '',
    type: MessageType.success,
  })
  const { isOpen, title, message, type } = notification

  const onOpen = (
    titleNotification: string,
    messageNotification: string,
    typeNotification: MessageType
  ) => {
    setNotification({
      isOpen: true,
      title: titleNotification,
      message: messageNotification,
      type: typeNotification,
    })
  }

  const onClose = useCallback(() => {
    setNotification({ ...notification, isOpen: false })
  }, [notification])

  useEffect(() => {
    if (isOpen) {
      setTimeout(onClose, 5000)
    }
  }, [isOpen, onClose])

  return (
    <NotificationContext.Provider value={{ onOpen, onClose }}>
      {children}
      {isOpen && (
        <NotificationMessage
          title={title}
          icon={type}
          description={
            message?.length > 80 ? (
              <div
                style={{
                  fontSize: '12.5px',
                  color: '#4a4a4a',
                  marginTop: 2,
                  fontFamily: 'sans-serif',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-all',
                  whiteSpace: 'pre-line',
                  hyphens: 'auto',
                }}
                dangerouslySetInnerHTML={{
                  __html: message.replaceAll('\n', '<br />'),
                }}
              />
            ) : (
              message
            )
          }
          onRequestClose={onClose}
          style={{
            maxHeight: `${message?.length > 100 ? '123px' : '85px'}`,
            width: `${message?.length >= 65 ? '362px' : '310px'}`,
          }}
        />
      )}
    </NotificationContext.Provider>
  )
}
export default NotificationProvider2
